import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "callDurationTimeStamp" : ""
}

const callDurationData= createSlice({
    name:'callDurationData',
    initialState,
    reducers : {
        callDurationTimestamp: (_state,payload)=>{
            return {
                "callDurationTimeStamp" : payload.payload
            }
        },
    }
});

export default callDurationData.reducer
export const callDurationTimestamp = callDurationData.actions.callDurationTimestamp

